interface LoadingProps {
  fullScreen?: boolean;
  message?: string;
}

export function Loading({ fullScreen = false, message = '読み込み中...' }: LoadingProps) {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-admin-bg/95 backdrop-blur-sm">
        <div className="rounded-2xl border border-admin-border bg-white px-8 py-6 text-center shadow-lg">
          <div className="mx-auto mb-3 h-8 w-8 animate-spin rounded-full border-4 border-admin-border border-t-admin-accent" />
          <p className="text-sm text-admin-muted">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-12">
      <div className="text-center">
        <div className="mx-auto mb-3 h-8 w-8 animate-spin rounded-full border-4 border-admin-border border-t-admin-accent" />
        <p className="text-sm text-admin-muted">{message}</p>
      </div>
    </div>
  );
}
